const actionVerbs = [
  'collect',
  'schedule',
  'measure',
  'verify',
  'check',
  'review',
  'submit',
  'prepare',
  'update',
  'adjust',
  'calibrate',
  'sample',
  'inspect',
  'report',
  'notify',
  'analyze',
  'purchase',
  'confirm'
]

const contextTokens = [
  'tank',
  'lot',
  'unit',
  'farm',
  'feed',
  'biomass',
  'mortality',
  'water',
  'oxygen',
  'temperature',
  'warehouse',
  'inventory'
]

export type ClarityAssessment = {
  score: number
  warnings: string[]
  suggestions: string[]
}

export const evaluateTaskClarity = (text: string | undefined | null): ClarityAssessment => {
  if (!text || text.trim().length === 0) {
    return {
      score: 0,
      warnings: ['Describe the task so teammates understand the goal.'],
      suggestions: ['Add an actionable sentence explaining what needs to happen.']
    }
  }

  const trimmed = text.trim()
  const lower = trimmed.toLowerCase()
  const warnings: string[] = []
  const suggestions: string[] = []

  if (trimmed.length < 20) {
    warnings.push('Add more detail so the task is self-explanatory.')
    suggestions.push('Clarify expected outcome or metric (e.g. target biomass, tank, or person).')
  }

  const containsVerb = actionVerbs.some((verb) => lower.includes(verb))
  if (!containsVerb) {
    warnings.push('Start with an action verb (e.g. collect, verify, adjust).')
  }

  const hasContext = contextTokens.some((token) => lower.includes(token))
  if (!hasContext) {
    warnings.push('Reference the farm, lot, tank, or metric the task affects.')
  }

  const score = Math.max(0, 100 - (warnings.length * 30))

  return {
    score,
    warnings,
    suggestions
  }
}
